import Main from './VisitsMain'

const Visits = {
  Main,
}

export default Visits
